import React, { FC, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import InvoicesDashboard from "./InvoicesDashboard";
import api from "../../../../api";
import { ReduxApplicationState } from "../../../../types/ReduxTypes/ReduxApplicationState";

type Props = {
  advertiserId: string;
};

const InvoicesCard: FC<Props> = ({ advertiserId }) => {
  const [invoices, setInvoices] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const user = useSelector((state: ReduxApplicationState) => state.user);

  useEffect(() => {
    const fetchAndSetInvoices = async () => {
      try {
        setIsLoading(true);
        const fetchedInvoices = await api.getInvoices(user.currentUser);
        setInvoices(fetchedInvoices);
      } catch (error) {
        console.log(`Error in fetchAndSetInvoices: ${error}`);
        setInvoices([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAndSetInvoices();
  }, [user.currentUser]);

  const filteredInvoices = useMemo(
    () => invoices.filter((invoice) => invoice.brandgenAdvertiserId === advertiserId),
    [invoices, advertiserId],
  );

  return <InvoicesDashboard invoices={filteredInvoices} isLoading={isLoading} />;
};

export default InvoicesCard;
